import { apiGet, apiPost, apiPut } from '../../_common';

export default {
  create(request) {
    return apiPost('/magenta/ecommerce/product/brand', request).then(result => result.response);
  },
  update(id, request) {
    return apiPut(`/magenta/ecommerce/product/brand/${id}`, request).then(result => result.response);
  },
  search(query) {
    return apiGet('/magenta/ecommerce/product/brand', query).then(result => result.response);
  },
  find(id) {
    return apiGet(`/magenta/ecommerce/product/brand/${id}`).then(result => result.response);
  },
};
